import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor (props: Props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError (): State {
    return { hasError: true };
  }
  override render (): ReactNode {
    const { fallback, children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return fallback;
    }

    return children;
  }
}
